export const AuthConstants = {
  TOKEN: 'token',
  AUTH_RENEW_HEADER: 'x-authorization',
  LOGIN_TOKEN: 'ee78105b0c8e41438ce23d60a5442aa7',
  AUTH_URL: 'https://pangeasvcqa.truckstop.com/',
};
